module.exports = __webpack_public_path__ + "img/image-placeholder.1d333a12.jpg";